<template>
  <div id="changePassword">
    <el-row>
      <el-col :offset="1">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules2"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          @submit.native.prevent
        >
          <el-form-item label="请输入密码:" prop="oldpass">
            <el-input type="password" v-model="ruleForm.oldpass"></el-input>
          </el-form-item>
          <el-form-item label="请输入新密码" prop="pass">
            <el-input type="password" v-model="ruleForm.pass"></el-input>
          </el-form-item>
          <el-form-item label="再次输入密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码不能小于六位"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value.length < 6) {
        callback(new Error("密码不能小于六位"));
      } else if (value == this.ruleForm.oldpass) {
        callback(new Error("不能与老密码一致"));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码不能小于六位"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldpass: "",
        pass: "",
        checkPass: ""
      },
      rules2: {
        oldpass: [{ validator: validatePass, trigger: "blur" }],
        pass: [{ validator: validatePass2, trigger: "blur" }],
        checkPass: [{ validator: validatePass3, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let message = await this.$doPost("/api/pass", this.ruleForm);
          if (message.msgCode == 0) {
            this.$alert("请重新登陆", "密码修改成功", {
              confirmButtonText: "确定",
              callback: action => {
                this.$doGet("/api/login_out");
                this.$router.push({ name: "Login" });
              }
            });
            // this.$message.success("密码修改成功, 请重新登陆");
            this.resetForm("ruleForm");
          } else {
            this.$message.error(message.msg);
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // next(val) {
    //   this.$message("asdfasdf");
    //   var e = document.createEvent("KeyboardEvents");
    //   if (val === "oldpass") {
    //     e.initKeyboardEvent("keydown", true, true, window, "U+0009"); // tab
    //   } else if (val === "pass") {
    //     e.initKeyboardEvent("keydown", true, true, window, "U+0009"); // tab
    //   } else if (val === "checkpass") {
    //     this.submitForm('ruleForm');
    //   }
    // }
  }
};
</script>
<style scoped>
.el-input {
  width: 200px;
}
.el-form {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/mysys/ChangePassword.vue